// INITIALIZE SCRIPT VARIABLES;

const domain = window.location.hostname;
let queryString = window.location.search;
let urlParams = new URLSearchParams(queryString);
let viewportWidth = window.innerWidth;
let viewportHeight = window.innerHeight;
let type = 'desktop';

const setViewport = (width, height) => {
  if (width < 768) {
    type = 'mobile';
  } else {
    type = 'desktop';
  }
  document.getElementById('main').style.height = `calc(${viewportHeight}px - 2.125rem)`;
}

setViewport(viewportWidth,viewportHeight);

// COOKIE + TRACKING SCRIPTS

const returnTrackingStatus = () => {
  if (!localStorage) {
    return console.log('Local storage is not available');
  }
  let status = localStorage.tracking;
  if (!localStorage.tracking) {
    status = 'UNSET';
  }
  return;
}

const refuseCookies = () => {
  localStorage.tracking = 'false';
  Shopify.analytics.publish('tracking_initialized', {consent: "false" });
  window.Shopify.customerPrivacy.setTrackingConsent({"analytics": false,"marketing": false}, returnTrackingStatus);
  document.getElementById('cookie-banner').innerHTML = `Got it! And we understand – we're not huge fans of trackers ourselves, so no worries!`;
  setTimeout(() => { document.getElementById('cookie-banner').style.display = 'none'; }, 3000);
}

const devourCookies = () => {
  localStorage.tracking = 'true';
  runTags();
  Shopify.analytics.publish('tracking_initialized', {consent: "true" });
  window.Shopify.customerPrivacy.setTrackingConsent({"analytics": true,"marketing": true}, returnTrackingStatus);
  document.getElementById('cookie-banner').innerHTML = `Thanks! We're not big fans of internet trackers ourselves, but the analytics info is really helpful as we try to build a better site for everyone!`;
  setTimeout(() => { document.getElementById('cookie-banner').style.display = 'none'; }, 3000);
}

const bakeCookies = () => {
  document.getElementById('cookie-banner').style.display = `block`;
  document.getElementById('eat-cookies').addEventListener('click', devourCookies);
  document.getElementById('refuse-cookies').addEventListener('click', refuseCookies);
}

const runTags = () => {

  Shopify.analytics.publish('tracking_initialized', {consent: "true" });
  Shopify.analytics.publish('opted_in', {consent: "true" });
  // console.log('RUNNING TAGS');
  
}

const banner = () => {
  if (!localStorage) {
    window.Shopify.customerPrivacy.setTrackingConsent({"analytics": false,"marketing": false}, returnTrackingStatus);
    Shopify.analytics.publish('tracking_initialized', {consent: "false" });
    return;
  }
  if (localStorage.tracking) {
    console.log(`Tracking status is set to ${status}`);
    if (localStorage.tracking == 'false') {
      window.Shopify.customerPrivacy.setTrackingConsent({"analytics": false,"marketing": false}, returnTrackingStatus);
      Shopify.analytics.publish('tracking_initialized', {consent: "false" });
    } else if (localStorage.tracking == 'true') {
      window.Shopify.customerPrivacy.setTrackingConsent({"analytics": true,"marketing": true}, returnTrackingStatus);
    }
    return;
  } else {
    // window.Shopify.customerPrivacy.setTrackingConsent(false, returnTrackingStatus);
    console.log('SET YOUR STATUS');
    bakeCookies();
  }
}

// ADD SUPPORT FOR FOCUS ON TAB USAGE

const checkTab = e => {
    if (e.key == 'Tab') {
        e.currentTarget.classList.add('keyboard-user');
    }
}
document.querySelector('body').addEventListener('keyup', checkTab);

const returnToShelves = e => {
  document.getElementById('product-dialog-container').remove();
  document.querySelectorAll('.coffee-shelf').forEach(shelf => {
    shelf.style.overflowX = 'auto';
  });
  let url = new URL(`https://${domain}/collections/shop`);
  window.history.pushState({ page: 'Shop' }, "", url);
  document.querySelectorAll('.tabbable').forEach(tab => {
    tab.setAttribute('tabindex', '0');
    tab.classList.remove('blur');
  })
  document.getElementById('mobile-coffee-shelf-container').classList.remove('blur');
  document.title = `Shop | Nonesuch Coffee`;
  return document.getElementById('coffee-shelves').focus();
}

// INITIALIZE REFRESH COMPONENTS

const clearContents = container => {
  return container.replaceChildren();
}

// FUNCTION DEFINITION

const closeLot = () => {
  document.getElementById('lot-information').remove();
  if (document.getElementById('product-main-conainer')) {
  document.getElementById('product-main-container').style.display = 'block';
  }
  let handle = window.location.pathname.split('/products/')[1];
    let url = new URL(`https://${domain}/products/${handle}`);
  window.history.pushState({ page: `${handle}` }, "", url);
}

if (urlParams.has('view') && urlParams.get('view') == 'lot' && urlParams.has('lot')) {
  document.getElementById('close-lot').addEventListener('click', closeLot);
  let productId = document.getElementById('lot-information').dataset.productid;
  let lotInformation = productLots[productId];
  if (lotInformation && lotInformation[urlParams.get('lot')]) {
    let theLot = productLots[productId][urlParams.get('lot')];
    document.getElementById('close-lot').addEventListener('click', closeLot);
    console.log(theLot);
    for (const [key, value] of Object.entries(theLot)) {
      let line = document.getElementById(`lot-${key}`);
      if (line) {
        line.insertAdjacentHTML('beforeend', value);
      }
    }
    document.getElementById('desktop-lot-number').insertAdjacentHTML('beforeend', theLot.lot);
      document.getElementById('mobile-lot-number').insertAdjacentHTML('beforeend', theLot.lot);
  } else {
    document.getElementById('lot-date').insertAdjacentHTML('beforeend', 'TBD');
    document.getElementById('lot-size').insertAdjacentHTML('beforeend', 'TBD');
    document.getElementById('lot-loss').insertAdjacentHTML('beforeend', 'TBD');
    document.getElementById('lot-best').insertAdjacentHTML('beforeend', 'TBD');
    document.getElementById('lot-notes').insertAdjacentHTML('beforeend', 'TBD');
    document.getElementById('lot-brewing').insertAdjacentHTML('beforeend', 'TBD');
    document.getElementById('lot-roast').insertAdjacentHTML('beforeend', 'TBD');
    document.getElementById('lot-time').insertAdjacentHTML('beforeend', 'TBD');
    document.getElementById('desktop-lot-number').insertAdjacentHTML('beforeend', 'TBD');
    document.getElementById('mobile-lot-number').insertAdjacentHTML('beforeend', 'TBD');
  }
}

const stockShelves = data => {
  let container = `
  <div style="max-height:100%;">
    ${data}
  </div>
  `
  document.getElementById('main').innerHTML = container;
  let url = new URL(`https://${domain}/pages/inside`);
  window.history.pushState({ page: "Inside the Store" }, "", url);
  coffeePoster = document.getElementById('to-browse-coffee');
  if (coffeePoster) {
    coffeePoster.addEventListener('click', browseCoffee);
    let coffeeShelf = document.getElementById('shelf-render-container');
      coffeeShelf.scrollTo({
    top: 0,
    left: 9999999999,
    behavior: "instant",
  });
  document.querySelectorAll('.product-link').forEach(link => {
    link.removeEventListener('click', renderDialog);
    link.addEventListener('click', renderDialog);
  });
  }
}

const pluralizeBags = e => {
  console.log(e.currentTarget.value);
  if (e.currentTarget.value == '') {
    console.log('EMPTY');
    return;
  }
  let quantity = parseInt(e.currentTarget.value);
  if (isNaN(quantity)) {
    console.log('IS NaN!');
    e.currentTarget.value = 1;
    quantity = 1;
  }
  document.querySelectorAll('.quantity-moneyfier').forEach(moneyfier => {
    moneyfier.innerText = `$${moneyfier.dataset.price * quantity}`;
  })
  if (quantity > 1) {
    document.querySelectorAll('.quantity-pluralizer').forEach(pluralizer => {
      if (pluralizer.innerText == 'bag') {
      pluralizer.innerText = `bags`;
      } else if (pluralizer.innerText == 'pack') {
        pluralizer.innerText = `packs`;
      }
    })
  } else {
    document.querySelectorAll('.quantity-pluralizer').forEach(pluralizer => {
      if (pluralizer.innerText == 'bags') {
       pluralizer.innerText = `bag`;
      } else if (pluralizer.innerText == 'packs') {
        pluralizer.innerText = `pack`;
      }
    })
  }
  return;
}

const showQuestions = e => {
  document.getElementById('tell-me-more').style.display = 'none';
  document.querySelector('.prebuy').style.display = 'none';
  document.getElementById('ask-questions').style.display = 'block';
  let questionPrompt = `<p>Yeah! Just let us know what you want to know about this particular coffee and we can try to answer your questions.</p>`;
  if (e.currentTarget && e.currentTarget.classList.contains('subscription-question')) {
    questionPrompt = `<p>Yeah! Just let us know what you want to know about subscriptions and we can try to answer your questions.</p>`;
  }
  if (e.currentTarget && e.currentTarget.classList.contains('sampler-question')) {
    questionPrompt = `<p>Yeah! Just let us know what you want to know about our sample pack and we can try to answer your questions.</p>`
  }
  document.getElementById('product-dialog').innerHTML = questionPrompt;
  document.getElementById('product-dialog').parentElement.scrollTo(0, 0);
  let container = document.getElementById('product-info-container');
  container.focus();
   if (localStorage && localStorage.tracking) {
    Shopify.analytics.publish('ask_question', { productTitle: currentProduct.title, productId: currentProduct.id });
  }
  return;
}

const showLot = e => {
  e.preventDefault();
  let mainContainer = document.getElementById('product-info-container');
  if (!mainContainer || !mainContainer.dataset.productid) {
    return;
  }
  let productId = mainContainer.dataset.productid;
  let theProduct = allProducts[productId];
  let lotSize = Object.keys(productLots[productId]).length;
  lotSize = `000${lotSize}`.slice(-3);
  let mostRecentLot = productLots[productId][`ns${lotSize}`];
  let lotPanel = window.components.lot_info;
  console.log(mostRecentLot);
  let bgColor = colors[theProduct.label_color];
  const whiteArray = ['Red', 'Blue', 'Purple', 'Orange'];
  let textColor = 'black';
  let blendMode = 'multiply';
  if (whiteArray.includes(theProduct.label_color)) {
    textColor = 'white';
    blendMode = 'lighten';
  }
  lotPanel = lotPanel.replaceAll(`#{productId}`, productId).replaceAll(`#{productTitle}`, theProduct.title).replaceAll(`#{lotBg}`, `label-${theProduct.label_color}`)
    .replaceAll(`#{lotBlend}`, blendMode).replaceAll(`#{lotColor}`, textColor).replaceAll(`#{lotImage}`, theProduct.lot_image).replaceAll(`#{lotNo}`, lotSize).replaceAll(`#{lotDate}`, mostRecentLot.date)
    .replaceAll(`#{lotSize}`, `${mostRecentLot.size.replace(' pounds', '')} pounds`).replaceAll(`#{lotTime}`, mostRecentLot.time).replaceAll(`#{lotLoss}`, mostRecentLot.loss).replaceAll(`#{lotRoast}`, mostRecentLot.roast)
    .replaceAll(`#{lotBest}`, mostRecentLot.best).replaceAll(`#{lotNotes}`, mostRecentLot.notes).replaceAll(`#{lotBrew}`, mostRecentLot.brewing);
  document.getElementById('product-dialog-container').insertAdjacentHTML('afterend', lotPanel);
  document.getElementById('close-lot').addEventListener('click', closeLot);

    let url = new URL(`${window.location.href}?view=lot&lot=ns${lotSize}`);
    window.history.pushState({ page: `${theProduct.title} Lot Information` }, "", url);
      if (localStorage && localStorage.tracking) {
    Shopify.analytics.publish('view_lot', {lot: lotSize, productTitle: theProduct.title, productId: theProduct.id });
  }
  
}

const setLotLinks = () => {
  document.querySelectorAll('.lot-link').forEach(link => {
    link.addEventListener('click', showLot);
  });
}



const answerQuestion = e => {
  let question = e.currentTarget;
  if (question.dataset.answer) {
      document.getElementById('tell-me-more').style.display = 'block';
  document.querySelector('.prebuy').style.display = 'block';
  document.getElementById('ask-questions').style.display = 'none';
  let container = document.getElementById('product-dialog');
  clearContents(container);
  container.insertAdjacentHTML('beforeend', question.dataset.answer);
    document.getElementById('product-dialog').parentElement.scrollTo(0, 0);
    }
    let container = document.getElementById('product-info-container');
    if (localStorage && localStorage.tracking) {
    Shopify.analytics.publish('answer_question', {question: question.dataset.question, productTitle: currentProduct.title, productId: currentProduct.id });
  }
    return container.focus();

}

const changedMind = e => {
    let theText = document.getElementById('product-dialog');
  if (theText) {
    theText.innerHTML = `<p>Oh, okay then! If you change your mind, use the handy website UI to let us know. If you still have questions, don't hesitate to ask!</p>`;
    document.getElementById('tell-me-more').style.display = 'block';
    document.getElementById('prebuy').style.display = 'block';
    document.getElementById('nevermind').style.display = 'none';
    document.getElementById('add-to-cart').style.display = 'none';
    let container = document.getElementById('product-info-container');
    document.getElementById('product-dialog').parentElement.scrollTo(0, 0);
    container.focus();
  }
}

const confirmSubscriptionChoices = e => {
  let form = document.querySelector('.shopify-product-form');
  if (!form) {
    return;
  }
  let bagNumber = form.querySelector('.subscription-bag-radio:checked');
  let brewMethods = form.querySelectorAll('.subscribe-brew-method-checkbox:checked');
  if (!bagNumber || bagNumber == null) {
    document.getElementById('add-to-cart').classList.add('choose-subscription');
    document.getElementById('atc-text').innerText = `CHOOSE A QUANTITY`;
    return;
  }
  if (!brewMethods || brewMethods.length < 1) {
    document.getElementById('add-to-cart').classList.add('choose-subscription');
    document.getElementById('atc-text').innerText = `CHOOSE AT LEAST ONE BREW METHOD`;
    return;
  }
    document.getElementById('add-to-cart').classList.remove('choose-subscription');
    document.getElementById('atc-text').innerText = `ADD TO CART`;
  return;
}

const atcDialog = e => {
  if (!e.currentTarget) {
    return;
  }
  let button = e.currentTarget;
  let price = button.dataset.price;
  let next = button.dataset.next;
  let quantity = button.dataset.inventory;
  let variant = button.dataset.variant;
  let process = 'atc';

let dialog = `
      <div data-product="${button.dataset.variant}" data-productid="${button.dataset.productid}" class="shopify-product-form">
<p>
<label>
Got it! We'll add
<input aria-label="Quantity to add to cart" inputmode="numeric" value="1" class="bag-quantity quantity sans" style="width:3rem; margin:.125rem .25rem; font-size:1rem;" type="number" min="1" max="${quantity}" pattern="[0-9]+" value="1">
<span class="quantity-pluralizer">bag</span> of coffee to your cart. The cost before shipping will be <span data-price="${button.dataset.price.replace('$', '')}" class="quantity-moneyfier">${ button.dataset.price }</span>.
</label>
</p>
</div>
`;

  if (button.dataset.subscription) {
    dialog = window.components.subscription_dialog;
    process = 'sub'
  }

  if (button.dataset.sampler) {
    dialog = `
      <div data-product="${button.dataset.variant}" data-productid="${button.dataset.productid}" class="shopify-product-form">
<p>
<label>
Got it! We'll add
<input aria-label="Quantity to add to cart" inputmode="numeric" value="1" class="bag-quantity quantity sans" style="width:3rem; margin:.125rem .25rem; font-size:1rem;" type="number" min="1" max="${quantity}" pattern="[0-9]+" value="1">
sample <span class="quantity-pluralizer">pack</span> to your cart. The cost before shipping will be <span data-price="${button.dataset.price.replace('$', '')}" class="quantity-moneyfier">${ button.dataset.price }</span>.
</label>
</p>
</div>
`;
  }

  let theText = document.getElementById('product-dialog');
  if (theText) {
    theText.innerHTML = dialog;
    document.getElementById('tell-me-more').style.display = 'none';
    button.style.display = 'none';
    document.getElementById('nevermind').style.display = 'flex';
    document.getElementById('add-to-cart').style.display = 'flex';
    document.querySelectorAll('.bag-quantity').forEach(pluralizer => {
      pluralizer.addEventListener('change', pluralizeBags);
      pluralizer.addEventListener('input', pluralizeBags);
    })
    let container = document.getElementById('product-info-container');
    document.getElementById('product-dialog').parentElement.scrollTo(0, 0);
    container.focus();
    if (process == 'sub') {
      document.getElementById('add-to-cart').classList.add('choose-subscription');
      document.getElementById('add-to-cart').classList.add('subscriber-atc');
      document.getElementById('atc-text').innerText = `CHOOSE A QUANTITY`;
      let form = document.querySelector('.shopify-product-form');
      if (form) {
        form.querySelectorAll('input').forEach(input => {
          input.addEventListener('input', confirmSubscriptionChoices);
        })
      }
    }
  }
   return;
}

const renderCoffee = (product) => {
  window.currentProduct = product;
  let currentDialog = document.getElementById('product-dialog-container');
  if (currentDialog) {
    currentDialog.remove();
  }
  let next = 'null';
  if (product.tentative == 'false' && product.next) {
    let date = product.next.split('-');
    next = `${parseInt(date[2])} ${window.months[parseInt(date[1])]}`
  } else if (product.next) {
    let date = product.next.split('-');
    let day = parseInt(date[2]);
    let month = window.months[parseInt(date[1])];
    let mon = parseInt(date[1]);
    if (day < 11) {
      next = `in early ${month}`;
    } else if (day < 21) {
      next = `in mid ${month}`;
    } else if (day < 33) {
      next = `in late ${month}`
    } else if (mon < 12) {
      next = `early ${window.months[mon+1]}`;
    } else {
      next = `early ${window.months[1]}`;
    }
  } else {
    next = 'an undetermined date in the future.';
  }
  let dialog = window.components.productDialog.replaceAll(`#{productTitle}`, product.title).replaceAll('#{productDescription}', product.description).replaceAll('#{productPrice}', product.price).replaceAll('#{productNext}', next).replaceAll(`#{productFarmInfo}`, product.farmInfo).replaceAll('#{productFirstVariantId}', product.firstVariantId).replaceAll(`#{productBrewing}`, product.brewing).replaceAll(`#{productInventory}`, product.inventory).replaceAll(`#{productElevation}`, product.elevation).replaceAll(`#{productSpecificOrigin}`, product.specific_origin).replaceAll(`#{productCultivars}`, product.cultivars).replaceAll(`#{productId}`, product.id).replaceAll(`#{productProcessingDetails}`, product.processing_details);
  if (product.title.includes('Subscription')) {
    dialog = window.components.productSubscription;
  }
  if (product.title.includes('Sample')) {
    dialog = window.components.productSample.replaceAll(`#{productTitle}`, product.title).replaceAll('#{productDescription}', product.description).replaceAll('#{productPrice}', product.price).replaceAll('#{productNext}', next).replaceAll(`#{productFarmInfo}`, product.farmInfo).replaceAll('#{productFirstVariantId}', product.firstVariantId).replaceAll(`#{productBrewing}`, product.brewing).replaceAll(`#{productInventory}`, product.inventory).replaceAll(`#{productElevation}`, product.elevation).replaceAll(`#{productSpecificOrigin}`, product.specific_origin).replaceAll(`#{productCultivars}`, product.cultivars).replaceAll(`#{productId}`, product.id).replaceAll(`#{productProcessingDetails}`, product.processing_details);
  }
    if (product.title.includes('Mystery Coffee')) {
    dialog = window.components.mystery_dialog.replaceAll(`#{productTitle}`, product.title).replaceAll('#{productDescription}', product.description).replaceAll('#{productPrice}', product.price).replaceAll('#{productNext}', next).replaceAll(`#{productFarmInfo}`, product.farmInfo).replaceAll('#{productFirstVariantId}', product.firstVariantId).replaceAll(`#{productBrewing}`, product.brewing).replaceAll(`#{productInventory}`, product.inventory).replaceAll(`#{productElevation}`, product.elevation).replaceAll(`#{productSpecificOrigin}`, product.specific_origin).replaceAll(`#{productCultivars}`, product.cultivars).replaceAll(`#{productId}`, product.id).replaceAll(`#{productProcessingDetails}`, product.processing_details);
  }

    let soldOut = `but unfortunately, we have completely sold out of this coffee and won’t be roasting it again.`;
  if (product.future == true) {
    soldOut = `but we have sold every bag of our current roast. We’ll announce the next roast of this coffee via our email list, so <a href="/pages/email">sign up</a> if you‘d like to receive updates on when we’ll be roasting this coffee again!`
  };
  let summary = window.components.productSummary.replaceAll(`#{productTitle}`, product.title).replaceAll(`#{productPrice}`, product.price).replaceAll(`#{productNext}`, next).replaceAll(`#{productSoldOut}`, soldOut);

  
  console.log(next);
  if (next !== 'null' && product.inventory > 0) {
    let theDate = new Date(product.next).getTime() + 86400000;
    let now = Date.now();
    console.log(theDate);
    if (now > theDate) {
      summary = window.components.roastedRecently.replaceAll(`#{productTitle}`, product.title).replaceAll(`#{productPrice}`, product.price).replaceAll(`#{productNext}`, next);
    }
    if (product.title.includes('Mystery')) {
      summary = window.components.recentMystery.replaceAll(`#{productTitle}`, product.title).replaceAll(`#{productPrice}`, product.price).replaceAll(`#{productNext}`, next);
    }
  } else if (product.inventory <= 0) {
    summary = window.components.outOfStock.replaceAll(`#{productTitle}`, product.title).replaceAll(`#{productPrice}`, product.price).replaceAll(`#{productNext}`, next).replaceAll(`#{productSoldOut}`, soldOut);
    dialog = dialog.replaceAll('id="prebuy"', 'id="soldout"');
    dialog = dialog.replaceAll('I WANT TO<br>BUY IT!', `SOLD OUT`);
  }
  dialog = dialog.replaceAll(`#{productSummary}`, summary);
  let shelves = document.getElementById('shelf-render-container');
  if (shelves) {
    document.getElementById('mobile-coffee-shelf-container').classList.add('blur');
    shelves.insertAdjacentHTML('afterend', dialog);
    document.querySelectorAll('.coffee-shelf').forEach(shelf => {
      shelf.style.overflowX = 'hidden';
    });
    let url = new URL(`https://${domain}/products/${product.handle}`);
    document.title = `${product.title} | Nonesuch Coffee`;
    window.history.pushState({ page: product.handle }, "", url);
    document.querySelectorAll('.tabbable').forEach(tab => {
      if (tab.nodeName !== 'INPUT' && tab.nodeName !== 'BUTTON') {
      tab.setAttribute('tabindex', '-1');
      if (tab.dataset.handle !== product.handle) {
      tab.classList.add('blur');
      };
      }
    });

    let desktopProduct = document.getElementById(`desktop-${product.handle}`);
    let mobileProduct = document.getElementById(`mobile-${product.handle}`);
    let desktopX = 0;
    let mobileX = 0;
    let desktopSvg = document.getElementById('desktop-shelves-svg');
    let mobileSvg = document.getElementById('mobile-shelves-svg');
    let desktopRatio = desktopSvg.viewBox.baseVal.height / desktopSvg.getBoundingClientRect().height;
    let mobileRatio = mobileSvg.viewBox.baseVal.height / mobileSvg.getBoundingClientRect().height;
    if (desktopProduct.dataset.index > 1 || mobileProduct.dataset.index > 1) {
    desktopX = desktopProduct.getBBox().x - 245;
    mobileX = (mobileProduct.dataset.index - 1) * 238.96 + 32;
    }

    document.getElementById('desktop-coffee-shelf-container').scrollTo({
  top: 0,
  left: desktopX / desktopRatio,
  behavior: "smooth",
});
  document.getElementById('mobile-coffee-shelf-container').scrollTo({
  top: 0,
  left: mobileX / mobileRatio,
  behavior: "smooth",
});
    console.log('MOBILE OFFSET');
    console.log(mobileX);
    console.log(mobileRatio);
    console.log(mobileX / mobileRatio);
    document.getElementById('product-dialog-container').querySelectorAll('.tabbable').forEach(tab => {
      tab.setAttribute('tabindex', '0');
    });
    let container = document.getElementById('product-info-container');
    container.focus();
    cartListeners();
  }

  setLotLinks();

if (localStorage && localStorage.tracking) {

  Shopify.analytics.publish('brew_coffee', { productTitle: product.title, productId: product.id, value: Number(product.price.replaceAll('$', '')), sku: Number(product.sku)  });
  Shopify.analytics.publish('click_coffee', { productTitle: product.title, productId: product.id, value: Number(product.price.replaceAll('$', '')), sku: Number(product.sku)  });
  console.log('ANALYTICS IS SEEING ' + product.title + ' as the product title.');
  
}

};

const renderDialog = e => {
  e.preventDefault();
  let id = e.currentTarget.dataset.coffeeid;
  if (id) {
    renderCoffee(window.allProducts[id]);
  }
}

setLotLinks();

document.querySelectorAll('.product-link').forEach(link => {
  link.addEventListener('click', renderDialog);
});

// CART FUNCTIONS

const resetProduct = e => {
  nevermind.addEventListener('click', changedMind);
  nevermind.removeEventListener('click', resetProduct);
  let changingMind = document.getElementById('nevermind-text');
    changingMind.innerText = `I CHANGED MY MIND`;
    let button = document.getElementById('add-to-cart');
  let text = document.getElementById('atc-text');
  text.innerText = `ADD TO CART`;
  button.addEventListener('click', addToCart);
  let dialog = document.getElementById('product-dialog');
  dialog.innerHTML = dialog.dataset.desc;
  nevermind.style.display = 'none';
  button.style.display = 'none';
  document.querySelector('.prebuy').style.display = 'block';
  document.getElementById('tell-me-more').style.display = 'block';
}

const subscribe = (button,form) => {
  if (button.classList.contains('choose-subscription')) {
    console.log('INCOMPLETE SUBSCRIPTION INFO!');
    return;
  }
        let text = document.getElementById('atc-text');

  let bagNumber = form.querySelector('.subscription-bag-radio:checked');
  let brewMethods = form.querySelectorAll('.subscribe-brew-method-checkbox:checked');
  let brews = [];
  let price = bagNumber.dataset.price;
  let product = allProducts[form.dataset.productid];
  brewMethods.forEach(brew => { brews.push(brew.value)});
  text.innerText = `ADDING...`;
  brews = brews.join(', ');
    let toAdd = {
    items: [
      {
    id: bagNumber.value,
    quantity: 1,
            properties: {
      'Brew Methods': brews
    }
  }
    ]
}
  console.log(toAdd);
    fetch('/cart/add.js', {
  method: 'POST',
  headers: {
    'Content-Type': 'application/json'
  },
  body: JSON.stringify(toAdd)
}).then(res => res.json()).then(response => {
    console.log(response);

    let changingMind = document.getElementById('nevermind-text');
    changingMind.innerText = 'BACK TO DETAILS';
    if (response.status == 422) {
      text.innerText = `ERROR ENCOUNTERED`;
      let issue = 10;
      if (response.description.includes(`You can't add more`)) {
        issue = 1;
      }
      if (response.description.includes('All')) {
        issue = 2;
      }
      updateCart(issue, productTitle);
      document.getElementById('product-dialog').focus();
      return;
    }


    
        text.innerText = `ADDED TO CART`;
    let atcConfirmation = `<p>Success! You've added a subscription to your cart! Let us know if you need anything else, or <a href="/cart">visit our cart page</a> if you're looking to check out.</p>`;
    document.getElementById('product-dialog').innerHTML = atcConfirmation;
        document.getElementById('product-dialog').focus();
    return updateCart();
  });

  let title = `${product.title} – ${bagNumber.dataset.variant}`

if (localStorage && localStorage.tracking) {
  // console.log('Tracking event');
}
}
  

const addToCart = e => {
  e.preventDefault();
  let form = document.querySelector('.shopify-product-form');
  if (!form) {
    sendCartError({form:false})
    return;
  }
  if (e.currentTarget && e.currentTarget.classList.contains('choose-subscription')) {
    return;
  }
  if (e.currentTarget && e.currentTarget.classList.contains('subscriber-atc')) {
    subscribe(e.currentTarget, form);
    return;
  }
  let id = form.dataset.product;
  let productTitle = e.currentTarget.dataset.name;
  let quantity = form.querySelector('.quantity').value;
  let button = document.getElementById('add-to-cart');
  let text = document.getElementById('atc-text');
  let product = allProducts[form.dataset.productid];
  text.innerText = `ADDING...`;
  button.removeEventListener('click', addToCart);
  nevermind.removeEventListener('click', changedMind);
  nevermind.addEventListener('click', resetProduct);
  if (parseInt(quantity) && parseInt(quantity) > form.querySelector('.quantity').getAttribute('max')) {
    quantity = form.querySelector('.quantity').getAttribute('max');
  }
  let toAdd = {
    items: [
      {
    id: id,
    quantity: parseInt(quantity) || 1
  }
    ]
            };
  console.log(toAdd);
  fetch('/cart/add.js', {
  method: 'POST',
  headers: {
    'Content-Type': 'application/json'
  },
  body: JSON.stringify(toAdd)
}).then(res => res.json()).then(response => {
    console.log(response);
    let changingMind = document.getElementById('nevermind-text');
    changingMind.innerText = 'BACK TO DETAILS';
    if (response.status == 422) {
      text.innerText = `ERROR ENCOUNTERED`;
      let issue = 10;
      if (response.description.includes(`You can't add more`)) {
        issue = 1;
      }
      if (response.description.includes('All')) {
        issue = 2;
      }
      updateCart(issue, productTitle);
      document.getElementById('product-dialog').focus();
      return;
    }
    let bags = response.items[0];
    let quant = parseInt(quantity) || 1;
    let bagText = `bags`;
    if (quant == 1) {
      bagText = `bag`;
    }

    let itemTitle = `of ${bags.title} `;

    if (bags.title.includes('Sample')) {
      itemTitle = ``;
      bagText = `sample packs`;
      if (quant == 1) {
        bagText = `sample pack`;
      }
    }
    
        text.innerText = `ADDED TO CART`;
    let atcConfirmation = `<p>Success! You've added ${quant} ${bagText} ${itemTitle}to your cart! Let us know if you need anything else, or <a href="/cart">visit our cart page</a> if you're looking to check out.</p>`;
    document.getElementById('product-dialog').innerHTML = atcConfirmation;
        document.getElementById('product-dialog').focus();
    return updateCart();
  });

if (localStorage && localStorage.tracking) {
  // console.log('Tracking event');
}
  
}

const updateCart = (issue, product) => {
  fetch('/cart.js', {
  method: 'GET',
  headers: {
    'Content-Type': 'application/json'
  }
}).then(res => res.json()).then(response => {
    if (issue) {
      console.log('ERROR!');
      console.log(issue);
      if (issue == 1 && document.getElementById('product-dialog')) {
        document.getElementById('product-dialog').innerHTML = `<p>It seems that we can't add that many quantities to your cart. Try adding fewer quantities, or please let us know if you think there's an issue with the site. Thanks!</p>`
      }
      if (issue == 2 && document.getElementById('product-dialog')) {
        document.getElementById('product-dialog').innerHTML = `<p>It seems that you already have all our current sellable bags of ${product} in your cart.</p>`
      }
      if (issue == 10 && document.getElementById('product-dialog')) {
        document.getElementById('product-dialog').innerHTML = `<p>There was an error adding to your cart. If you feel like this is a website issue, please contact us so we can fix it. Thanks!</p>`
      }
    }


    
    document.getElementById('cart-footer-quantity').innerText = response.item_count;
    if (document.getElementById('receipt-tape')) {
    buildReceipt(response);
    }
    let container = document.getElementById('product-info-container');
    if (container) {
    container.focus();
    }
    return;
  });
}

let removeItem = e => {
  let key = e.currentTarget.dataset.key;
  if (!key) {
    return console.log('THERE HAS BEEN AN ERROR!')
  }
  let toRemove = {
  id: key,
  quantity: 0
}

  fetch('/cart/change.js', {
  method: 'POST',
  headers: {
    'Content-Type': 'application/json'
  },
  body: JSON.stringify(toRemove)
}).then(res => res.json()).then(response => {
    console.log(response);
    let line = document.getElementById(`line-${key}`);
    if (line) {
      line.remove();
    }
    updateCart();
  })
}

const sendCartError = data => {
  if (!data.form) {
    return console.log('NO FORM DATA!');
  }
}

if (!window.shippingCost) {
  window.shippingCost = 5;
}

if (!window.freeThreshold) {
  window.freeThreshold = 3;
}

const buildReceipt = cart => {
  let total = cart.total_price / 100;
  console.log('TOTAL');
  console.log(total);
  console.log('ITEMS');
  console.log(cart.item_count)
  let shipping = 0;
  let quantity = 0;
  cart.items.forEach(item => {
    if (!item.title.includes('Subscription')) {
      quantity += item.quantity;
      if (quantity < freeThreshold) {
        shipping = shippingCost;
      }
    }
  })
  console.log('SHIPPING');
  console.log(shipping);
  let registerTotal = total + shipping;
  registerTotal = `0000` + registerTotal.toString();
  document.getElementById('register-total').innerText = registerTotal.slice(-4);
  document.getElementById('receipt-subtotal').innerText = `$${total}`;
  document.getElementById('receipt-shipping-total').innerText = `$${shipping}`;
  document.getElementById('receipt-pretax-total').innerText = `$${total + shipping}`;
}

// INITIALIZE TRACKING CONSENT API

window.Shopify.loadFeatures(
 [
   {
     name: 'consent-tracking-api',
     version: '0.1',
   },
 ],
 error => {
   if (error) {
     throw error; // if you want to raise
   }
   banner();
 },
);

// INITIALIZE EVENT LISTENERS

const cartListeners = () => {

  const backToShelves = document.getElementById('back-to-shelves');
  if (backToShelves) {
    backToShelves.addEventListener('click', returnToShelves);
  }

  let tellMeMore = document.getElementById('tell-me-more');
  let questions = document.querySelectorAll('.product-question');

  let nevermind = document.getElementById('nevermind');
  if (nevermind) {
    nevermind.addEventListener('click', changedMind);
  }

  if (tellMeMore) {
    tellMeMore.addEventListener('click', showQuestions);
    questions.forEach(question => {
      question.addEventListener('click', answerQuestion);
    });
  }

  let atcButton = document.getElementById('add-to-cart');
  if (atcButton) {
    atcButton.addEventListener('click', addToCart);
  }

  let prebuy = document.getElementById('prebuy');
  if (prebuy) {
    prebuy.addEventListener('click', atcDialog);
  }

  let atc = document.querySelectorAll('.shopify-product-form');
  if (atc.length) {
    atc.forEach(add => {
    add.addEventListener('submit', addToCart);
    });
  }
}

cartListeners();

if (window.location.pathname.includes('/products/')) {

  let handle = window.location.pathname.split('/products/')[1];
  let desktopSvg = document.getElementById('desktop-shelves-svg');
  let mobileSvg = document.getElementById('mobile-shelves-svg');
  document.getElementById('mobile-coffee-shelf-container').classList.add('blur');
    document.querySelectorAll('.coffee-shelf').forEach(shelf => {
      shelf.style.overflowX = 'hidden';
    });
    document.querySelectorAll('.tabbable').forEach(tab => {
      if (tab.nodeName !== 'INPUT' && tab.nodeName !== 'BUTTON') {
      tab.setAttribute('tabindex', '-1');
      if (tab.dataset.handle !== handle) {
      tab.classList.add('blur');
      };
      };
    });
  if (desktopSvg) {
    console.log('MOBILE!');
    let style = window.getComputedStyle(desktopSvg)
    let matrix = new DOMMatrixReadOnly(style.transform)
    console.log('TRANSFORM X');
    console.log(matrix.m41);
    let xOffset = matrix.m41 * -1;
    desktopSvg.style.transform = `translate(0, 0)`;
        let desktopRatio = desktopSvg.viewBox.baseVal.height / desktopSvg.getBoundingClientRect().height;
    document.querySelector('.coffee-shelf').scrollTo({
  top: 0,
  left: xOffset / desktopRatio,
  behavior: "instant",
});
}
  if (mobileSvg) {
        let mobileRatio = mobileSvg.viewBox.baseVal.height / mobileSvg.getBoundingClientRect().height;

    let style = window.getComputedStyle(mobileSvg)
    let matrix = new DOMMatrixReadOnly(style.transform)
    console.log('TRANSFORM X');
    console.log(matrix.m41);
    let xOffset = matrix.m41 * -1;
    mobileSvg.style.transform = `translate(0, 0)`;
    document.getElementById('mobile-coffee-shelf-container').scrollTo({
  top: 0,
  left: xOffset / mobileRatio,
  behavior: "instant",
});
  }

let product = allProducts[document.getElementById('product-dialog-container').dataset.productid];
  if (product && localStorage && localStorage.tracking) {
  // console.log('Tracking event');

  }
}

const answerFaq = e => {
  let question = e.currentTarget;
  let answerDialog = document.getElementById('faq-dialog');
  answerDialog.innerHTML = question.dataset.answer;
  document.getElementById('faq-info-container').focus();
  answerDialog.parentElement.scrollTo(0,0);
}

const renderAbout = () => {
  document.querySelector('main').insertAdjacentHTML('beforeend', components.about_page );
  let posters = document.getElementById('poster-render-container');
  if (posters) {
    posters.classList.add('blur');
    let url = new URL(`https://${domain}/pages/about`);
    window.history.pushState({ page: "About" }, "", url);
  }
  document.getElementById('close-about').addEventListener('click', closeAbout);
}

const renderEmail = () => {
  document.querySelector('main').insertAdjacentHTML('beforeend', components.email_signup );
  let posters = document.getElementById('poster-render-container');
  let shelf = document.getElementById('shelf-render-container');
    let hoppUp = document.getElementById('email-hopp-up');
  if (posters) {
    posters.classList.add('blur');
    let url = new URL(`https://${domain}/pages/email`);
    window.history.pushState({ page: "Email" }, "", url);
  } else if (shelf) {
    shelf.classList.add('blur');
    hoppUp.classList.add('blur');
  }
  if (localStorage && localStorage.tracking) {
    let emailTags = document.getElementById('email-tags');
    emailTags.value = `${emailTags.value},ESULC ${localStorage.last},ESULU ${localStorage.lastUTM}`;
  }
  document.getElementById('close-email').addEventListener('click', closeEmail);
}

const renderContact = () => {
  document.querySelector('main').insertAdjacentHTML('beforeend', components.contact_us );
  let posters = document.getElementById('poster-render-container');
  if (posters) {
    posters.classList.add('blur');
    let url = new URL(`https://${domain}/pages/contact-us`);
    window.history.pushState({ page: "Contact" }, "", url);
  }
  document.getElementById('close-contact').addEventListener('click', closeContact);
}

const closeFaqs = () => {
  document.getElementById('faqs-overlay').remove();
        let posters = document.getElementById('poster-render-container');
  if (posters) {
    posters.classList.remove('blur');
    let url = new URL(`https://${domain}/pages/inside`);
    window.history.pushState({ page: "Inside the Store" }, "", url);
  }
  let product = document.getElementById('product-dialog-container');
  if (product) {
    product.classList.remove('blur');
    document.getElementById('desktop-coffee-shelf-container').classList.remove('blur');
    let url = new URL(window.location.href.replace(window.location.hash,''));
    window.history.pushState({}, "", url);
  }
}

const closeEmail = () => {
  document.getElementById('email-overlay').remove();
  let url = new URL(window.location.href.replace(window.location.hash,''));
  window.history.pushState({}, "", url);
  let posters = document.getElementById('poster-render-container');
  let shelf = document.getElementById('shelf-render-container');
  let hoppUp = document.getElementById('email-hopp-up');
  if (posters) {
    posters.classList.remove('blur');
    let url = new URL(`https://${domain}/pages/inside`);
    window.history.pushState({page: "Inside the Store"  }, "", url);
  } else if (shelf) {
    shelf.classList.remove('blur');
    hoppUp.classList.remove('blur');
    let url = window.location.href.split('?')[0];
    window.history.pushState({}, "", url);
  }
}

const closeContact = () => {
  document.getElementById('contact-overlay').remove();
  let url = new URL(window.location.href.replace(window.location.hash,''));
  window.history.pushState({}, "", url);
      let posters = document.getElementById('poster-render-container');
  if (posters) {
    posters.classList.remove('blur');
    let url = new URL(`https://${domain}/pages/inside`);
    window.history.pushState({ page: "Inside the Store" }, "", url);
  }
}

const closeAbout = () => {
  document.getElementById('about-overlay').remove();
  let url = new URL(window.location.href.replace(window.location.hash,''));
  window.history.pushState({}, "", url);
      let posters = document.getElementById('poster-render-container');
  if (posters) {
    posters.classList.remove('blur');
    let url = new URL(`https://${domain}/pages/inside`);
    window.history.pushState({ page: "Inside the Store" }, "", url);
  }
}

const renderFaqs = () => {
    document.querySelector('main').insertAdjacentHTML('beforeend', window.components.faqs_page );
    document.querySelectorAll('.faq-question').forEach(question => {
      question.addEventListener('click', answerFaq);
    })
    let posters = document.getElementById('poster-render-container');
  if (posters) {
    posters.classList.add('blur');
    let url = new URL(`https://${domain}/pages/faqs`);
    window.history.pushState({ page: "FAQs" }, "", url);
  }
  let product = document.getElementById('product-dialog-container');
  if (product) {
    product.classList.add('blur');
    document.getElementById('desktop-coffee-shelf-container').classList.add('blur');
  }
    document.getElementById('close-faqs').addEventListener('click', closeFaqs);
}

const reactFaqs = e => {
  e.preventDefault();
  renderFaqs();
}

const reactAbout = e => {
  e.preventDefault();
  renderAbout();
}

const reactEmail = e => {
  e.preventDefault();
  renderEmail();
}

const reactContact = e => {
  e.preventDefault();
  renderContact();
}

const checkHash = () => {
if (window.location.hash.includes('#faqs')) {
  renderFaqs();
}
}

document.querySelectorAll('.faqs-link').forEach(link => {
  link.addEventListener('click', reactFaqs);
});

document.querySelectorAll('.about-link').forEach(link => {
  link.addEventListener('click', reactAbout);
});

document.querySelectorAll('.email-link').forEach(link => {
  link.addEventListener('click', reactEmail);
});

document.querySelectorAll('.contact-link').forEach(link => {
  link.addEventListener('click', reactContact);
});

if (window.location.pathname.includes('/pages/about')) {
  let posters = document.getElementById('poster-render-container');
  if (posters) {
    posters.classList.add('blur');
  }
  document.getElementById('close-about').addEventListener('click', closeAbout);
}

if (window.location.pathname.includes('/pages/faqs')) {
  document.querySelectorAll('.faq-question').forEach(question => {
      question.addEventListener('click', answerFaq);
    })
    let posters = document.getElementById('poster-render-container');
  if (posters) {
    posters.classList.add('blur');
  }
  let product = document.getElementById('product-dialog-container');
  if (product) {
    product.classList.add('blur');
  }
    document.getElementById('close-faqs').addEventListener('click', closeFaqs);
}

if (window.location.pathname.includes('/pages/contact-us')) {
    let posters = document.getElementById('poster-render-container');
  if (posters) {
    posters.classList.add('blur');
  }
    document.getElementById('close-contact').addEventListener('click', closeContact);
}

if (window.location.pathname.includes('/pages/email')) {
    let posters = document.getElementById('poster-render-container');
  if (posters) {
    posters.classList.add('blur');
  }
    document.getElementById('close-email').addEventListener('click', closeEmail);
}

if (window.location.href.includes('?customer_posted=true')) {
    if (localStorage && localStorage.tracking && localStorage.tracking == 'true') {
          Shopify.analytics.publish('email_signup', {email: null });
                    }
  localStorage.email = 'signed';
  renderEmail();
}

window.addEventListener('hashchange', checkHash);
checkHash();

let removeItems = document.querySelectorAll('.remove-item');
if (removeItems.length) {
  removeItems.forEach(item => {
    item.addEventListener('click', removeItem);
  })
}

window.addEventListener("resize", (e) => {
  viewportWidth = window.innerWidth;
  viewportHeight = window.innerHeight;
  setViewport(viewportWidth,viewportHeight);
});

const closeEmailPopup = e => {
  localStorage.email = 'closed';
  document.getElementById('email-popup').remove();
}

const signUpPopup = () => {
  localStorage.email = 'just-signed';
}

const closeEmailHoppUp = () => {
  localStorage.email = 'closed';
  let choice = document.querySelector('.email-popup-answer');
  if (choice) {
    choice.remove();
  }
  document.querySelectorAll('.hoppup-8').forEach(hoppup => {
    hoppup.querySelector('p').innerText = 'Okay, we understand – your inbox is probably filled with tons of things you didn’t sign up for. We won’t bother you about it again (or at least won’t as long as your browser data doesn’t get cleared). Going away in 3 …';
    setTimeout(() => { hoppup.querySelector('p').innerText += ' 2 …'}, 1000);
    setTimeout(() => { hoppup.querySelector('p').innerText += ' 1 …'}, 2000);
  });
  setTimeout(() => {
  document.getElementById('hopp-up-container').style.height = '0';
        },3000);
  setTimeout(() => {
  document.getElementById('email-hopp-up').remove();
  }, 4200);
}

const answerHoppUpQuestion = e => {
  if(!e) {
  return;
  }
  let choice = e.currentTarget.dataset.choice;
  if (choice == 'signup') {
    renderEmail();
  }
  if (choice == 'nothanks') {
    closeEmailHoppUp();
  }
}

const showEmailPopup = email => {
  let popup = document.getElementById('email-hopp-up');
  if (popup) {
  if (email && email == 'just-signed') {
    return;
  }
  if (window.location.href.includes('?customer_posted=true')) {
    return;
  }
  if (document.getElementById('popup-subscribe')) {
    document.getElementById('popup-subscribe').addEventListener('click', signUpPopup)
  }
    setTimeout(() => {
  popup.classList.remove('none');
      setTimeout(() => {
      document.getElementById('hopp-up-graphic').classList.add('hopp-up');
        },200);
      let emailHeight = document.getElementById('email-hoppup-dialog-box').offsetHeight;
      document.getElementById('hopp-up-container').style.height = `${emailHeight}px`;
      document.querySelectorAll('.email-hopp-up-question').forEach(question => {
        question.addEventListener('click', answerHoppUpQuestion);
      })
      setTimeout(() => {
        document.getElementById('email-hoppup-dialog-box').style.opacity = 1;
      }, 1000);
      
    }, 1000);
    
}
  return;
}

const triggerHoppUp = () => {
  if (!localStorage.tracking) {
    return setTimeout(() => { triggerHoppUp(); }, 3000);
  }
  let email = localStorage.email;
  if (!email) {
    setTimeout(() => {
    showEmailPopup();
    },1000);
  }
  return;
}

const setAttribution = () => {
    let params = new URLSearchParams(window.location.search);
    let referrer = document.referrer;
    let current = referrer;
  if (!localStorage.initialTimestamp) {
    localStorage.initialTimestamp = new Date(Date.now()).toString();
  }
    if (!referrer) {
      current = 'direct';
    } else if (referrer.includes('instagram') || referrer.includes('.meta') || referrer.includes('facebook')) {
      current = "Instagram";
    } else if (referrer.includes('google')) {
      current = "Google";
    } else if (referrer.includes('reddit')) {
      current = "Reddit";
    }
    let utms = null;
    if (params) {
      // DO NOTHING
      if (params.has('utm_content')) {
        utms = params.get('utm_content');
      } else {
        utms = params;
      }
      if (params.has('utm_source') && params.get('utm_source') == 'facebook' || params.get('utm_source') == 'instagram' || params.get('utm_source') == 'meta') {
        current = 'Instagram';
        if (params.has('utm_medium') && params.get('utm_medium') == 'paid') {
          current = 'Paid Instagram'
        }
        if (params.has('utm_content')) {
          utms = params.get('utm_content');
        }
      }
    }
      if (!localStorage.sessionTimestamp) {
      localStorage.sessionTimestamp = Date.now();
      localStorage.first = current;
      localStorage.firstUTM = utms;
      localStorage.last = current;
      localStorage.lastUTM = utms;
      return;
    }
    let time = Date.now();
    if (time - localStorage.sessionTimestamp > 86400000) {
      localStorage.sessionTimestamp = Date.now();
      localStorage.last = current;
      localStorage.lastUTM = utms;
      if (!localStorage.first) {
        localStorage.first = current;
        localStorage.firstUTM = utms;
      }
      return;
    }
  return;
}

let cartForm = document.getElementById('cart_form');

if (cartForm && localStorage && localStorage.tracking && localStorage.tracking == 'true') {
  let attributes = {
    'attributes': {
      '__first': localStorage.first,
      '__last': localStorage.last,
      '__firstUTM': localStorage.firstUTM,
      '__lastUTM': localStorage.lastUTM,
      '__initial': localStorage.initialTimestamp
    }
  };
  fetch('/cart/update.js', {
    method: 'POST',
      headers: {
    'Content-Type': 'application/json'
  },
    body: JSON.stringify(attributes)
  }).then(res => res.json()).
    then(response => {
      console.log(response)
    })
}

if (localStorage) {
  let email = localStorage.email;
  console.log('Running local storage check!');
  if (!email) {
  triggerHoppUp();
  }
    setAttribution();
}

// ADD LIBRARY SUPPORT

    const openBook = e => {
        let spine = e.currentTarget;
        let dewey = books[spine.dataset.book];
        let image = `<img src="${dewey.image}" alt="${dewey.alt}" width="${dewey.width}" height="${dewey.height}">`;
        let copy = bookBinding;
        copy = copy.replaceAll('#articleTitle', dewey.title).replaceAll(`#articleContent`, dewey.content).replaceAll(`#articleImage`, image);

        var downloadingImage = new Image();
        downloadingImage.onload = () => {
          image.src = this.src;
                  document.getElementById('coffee-shelves').insertAdjacentHTML('afterbegin', copy);
        document.querySelectorAll('.library-return').forEach(checkin => {
            checkin.addEventListener('click', checkIn);
        });
          let url = new URL(`https://${domain}/blogs/${dewey.handle}`);
          window.history.pushState({ page: `${dewey.title} | Nonesuch Coffee` }, "", url);
            if (localStorage && localStorage.tracking) {
              Shopify.analytics.publish('read_book', { page_title: dewey.title, url: `https://${domain}/blogs/${dewey.handle}` });
            }
        };

downloadingImage.src = `${dewey.image}`;


    }

    document.querySelectorAll('.book-spine').forEach(spine => {
        spine.addEventListener('click', openBook);
    })

    const checkIn = e => {
        document.getElementById('article-container').remove();
        let url = new URL(`https://${domain}/blogs/drink-coffee-before-go`);
        window.history.pushState({ page: `DRinK COffEE BEfORE GO? | Nonesuch Coffee` }, "", url);
    }

    document.querySelectorAll('.library-return').forEach(checkin => {
        checkin.addEventListener('click', checkIn);
    });

    if (window.location.pathname.includes('article')) {
      if (localStorage && localStorage.tracking) {
      let bookTitle = document.querySelector('.h2').innerText;
      let bookUrl = `https://${window.location.hostname}${window.location.pathname}`;
      if (localStorage && localStorage.tracking) {
              Shopify.analytics.publish('read_book', { page_title: bookTitle, url: bookUrl });
            }
          }
    };